export * from "./network-config"
export * from "./useContracts"
export * from "./types"
export * from "./chains"
export * from "./utils"

export { Publication } from "./types/contracts/Publication"
export { KnowledgeToken } from "./types/contracts/KnowledgeToken"
export { Publication__factory } from "./types/factories/contracts"
export { KnowledgeToken__factory } from "./types/factories/contracts"
